/**
 * SIMS-9304 — whether a request was refused with 403.
 *
 * The services reject with the response body (`err.response?.data || err`), which for a
 * Nest HttpException carries `statusCode`; anything that rejects with the raw axios error
 * carries `response.status` instead. Both are read so a caller does not need to know which
 * shape it was handed.
 */
export const isForbidden = (error: unknown): boolean => {
	if (typeof error !== "object" || error === null) return false;
	const e = error as { statusCode?: unknown; response?: { status?: unknown } };
	return e.statusCode === 403 || e.response?.status === 403;
};
